module.exports = __webpack_public_path__ + "img/detail-introduce.14d1bd50.svg";